// AUTHOR: Gopalakrishnan
// VERSION: 0.0.1
// LAST EDIT: Gopalakrishnan
// DATE: 5/01/2026
// DESCRIPTION: DEALER REPORT PAGE
const DealerReportActionTypes = {
	/************* FETCH DEALER REPORT LIST START ******************* */
	FETCH_DEALER_REPORT_START: 'fetch_dealer_report_start',
	FETCH_DEALER_REPORT_SUCCESS: 'fetch_dealer_report_success',
	FETCH_DEALER_REPORT_FAILURE: 'fetch_dealer_report_failure',
	FETCH_DEALER_REPORT_RESPONSE_RESET: 'fetch_dealer_report_response_reset',
	FETCH_DEALER_REPORT_RESPONSE_CHANGED: 'fetch_dealer_report_response_changed',
	/************* FETCH DEALER REPORT LIST END ******************* */
};
export default DealerReportActionTypes;
